export default __webpack_public_path__ + "static/media/Background.b3a00368.svg";